import { useMemo } from 'react';
import { getChannelMessageMaxLength } from 'app/utils/conversation';
import { gsm7ExtendedOnlyRegex, gsm7ExtendedRegex, gsm7Regex, smsMessageLimits, } from './utils/config';
/** Represents a hook that counts the number of characters. */
export const useCharacterCounter = ({ channel, text, isPublicReply, }) => {
    /** The detected encoding. */
    const encoding = useMemo(() => {
        if (channel === 'sms') {
            if (text.match(gsm7Regex)) {
                return 'GSM-7';
            }
            if (text.match(gsm7ExtendedRegex)) {
                return 'GSM-7-EXTENDED';
            }
        }
        return 'UTF-16';
    }, [channel, text]);
    /** The count and number of messages. */
    const { count, messages } = useMemo(() => {
        if (channel !== 'sms') {
            return { count: text.length, messages: 1 };
        }
        const count = encoding === 'GSM-7-EXTENDED'
            ? [...text].reduce((length, character) => length + (character.match(gsm7ExtendedOnlyRegex) ? 2 : 1), 0)
            : text.length;
        const messages = Math.ceil(count /
            (count <= smsMessageLimits[encoding].single
                ? smsMessageLimits[encoding].single
                : smsMessageLimits[encoding].multiple));
        return { count, messages };
    }, [encoding, channel, text]);
    /** The editor character limit. */
    const limit = useMemo(() => getChannelMessageMaxLength(channel, isPublicReply), [channel, isPublicReply]);
    return { encoding, count, messages, limit };
};
